<template>
    <div
        class="switch-container"
        :class="{ 'is-active': value }"
        @click="toggle"
    >
        <span class="switch-core"></span>
    </div>
</template>

<script>
export default {
    name: 'SwitchButton',
    props: {
        // 接收 v-model 的值
        value: {
            type: Boolean,
            default: false
        },
        // 可选：自定义激活时的背景色，默认设为图片中的深灰色
        activeColor: {
            type: String,
            default: '#333333'
        },
        // 可选：自定义关闭时的背景色
        inactiveColor: {
            type: String,
            default: '#dcdfe6'
        }
    },
    methods: {
        toggle() {
            // 触发 input 事件以更新 v-model
            this.$emit('input', !this.value);
            // 同时触发 change 事件，方便其他逻辑监听
            this.$emit('change', !this.value);
        }
    }
}
</script>

<style scoped>
/* 开关容器 (跑道) */
.switch-container {
    display: inline-block;
    position: relative;
    width: 50px;  /* 宽度 */
    height: 26px; /* 高度 */
    border-radius: 13px; /* 圆角为高度的一半 */
    background-color: #dcdfe6; /* 默认(关闭)背景色 */
    cursor: pointer;
    transition: background-color 0.3s ease; /* 背景色过渡动画 */
    /* 防止被选中文字 */
    user-select: none;
}

/* 激活状态 (On) */
.switch-container.is-active {
    background-color: #333333; /* 对应图片中的深灰色 */
}

/* 白色圆球 (滑块) */
.switch-core {
    position: absolute;
    top: 2px;
    left: 2px;
    width: 22px; /* 圆球直径 = 高度 - 2*top */
    height: 22px;
    border-radius: 100%;
    background-color: #fff;
    transition: transform 0.3s ease; /* 移动过渡动画 */
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.4); /* 增加一点阴影立体感 */
}

/* 激活状态下圆球的位置 */
.switch-container.is-active .switch-core {
    /* 向右移动: 容器宽(50) - 圆球宽(22) - 左边距(2) - 右边距预留(2) = 24px */
    transform: translateX(24px);
}
</style>